import Vue from "vue"
import { GetterTree, MutationTree } from "vuex"

import { RoomResource, RoomsState } from "~/store/rooms/rooms.types"
import { RootState } from "~/store/store.types"
import { getResource } from "~/utils/store"

export const state = (): RoomsState => ({
  data: {},
  filters: {}
})

export const mutations: MutationTree<RoomsState> = {
  SET_ROOM (state, room: RoomResource) {
    const { id } = room

    Vue.set(state.data, id, room)
  }
}

export const getters: GetterTree<RoomsState, RootState> = {
  resourceById (state, _, __, rootGetters) {
    return (id: string, included: string | string[] = []) =>
      getResource<any>(state, id, rootGetters, included)
  }
}
